module.exports = __webpack_public_path__ + "img/four_col.fe6e79ec.svg";